/** Contexto típico de error de una Edge Function de Supabase (message + context con json/body). */
export interface EdgeFunctionErrorContext {
  message?: string;
  context?: {
    json?: () => Promise<unknown>;
    body?: unknown;
  };
}

/** Respuesta de datos que puede traer error/details. */
export interface EdgeFunctionResponseData {
  error?: string;
  details?: string;
}

/**
 * Extrae un mensaje legible de un error de Edge Function (context.json, body o responseData).
 */
export async function parseEdgeFunctionError(
  edgeError: EdgeFunctionErrorContext,
  responseData?: EdgeFunctionResponseData
): Promise<string> {
  let msg = edgeError.message || 'Error al comunicarse con el servidor';
  try {
    const ctx = edgeError.context;
    if (ctx?.json && typeof ctx.json === 'function') {
      const body = (await ctx.json()) as EdgeFunctionResponseData;
      if (body?.error) msg = body.details ? `${body.error}: ${body.details}` : body.error;
    } else if (ctx?.body != null) {
      const body =
        typeof ctx.body === 'string'
          ? (JSON.parse(ctx.body) as EdgeFunctionResponseData)
          : (ctx.body as EdgeFunctionResponseData);
      if (body?.error) msg = body.details ? `${body.error}: ${body.details}` : body.error;
    }
  } catch {
    /* usar msg por defecto */
  }
  if (responseData?.error) {
    msg = responseData.details ? `${responseData.error}: ${responseData.details}` : responseData.error;
  }
  if (msg.includes('non-2xx') || msg === 'Error al comunicarse con el servidor') {
    return 'No se pudo completar la acción. Comprueba permisos y que la función está desplegada.';
  }
  return msg;
}
